import { render, staticRenderFns } from "./usher_page_v2.vue?vue&type=template&id=0b63f4d0&"
import script from "./usher_page_v2.vue?vue&type=script&lang=js&"
export * from "./usher_page_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports